import { ActionCableContext } from '@/providers/action-cable/action-cable.provider';
import { useContext, useEffect, useRef } from 'react';
import { useChannel } from '../use-channel/use-channel';
import { ChannelNameWithParams } from 'actioncable';

export const useWebsocket = <T>(channel: ChannelNameWithParams, received: (data: T) => void) => {
  const actionCable = useContext(ActionCableContext);
  const { subscribe, unsubscribe } = useChannel(actionCable.cable);
  const receivedRef = useRef(received);

  useEffect(() => {
    receivedRef.current = received;
  }, [received]);

  const channelKey = JSON.stringify(channel);

  useEffect(() => {
    const stableReceived = (data: T) => {
      receivedRef.current(data);
    };

    subscribe(channel, {
      received: stableReceived,
    });

    return () => {
      unsubscribe();
    };
  }, [channelKey, subscribe, unsubscribe]);
};
